import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataEnum,
  ODataDateTime,
  ODataDecimal,
  ODataInteger,
  ODataBoolean,
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 3,
});

// public Guid PlanIdentityId { get; set; }
// public int CalendarYear { get; set; }
// public int CalendarMonth { get; set; }
// public EligibilityHourBankEvaluationStatus Status { get; set; }
// public DateTime Timestamp { get; set; }
// public virtual List<EligibilityHourBankEvaluationResult> EligibilityHourBankEvaluationResults { get; set; }

export default function getHeaders(enums) {
  return [
    new ODataHeader({
      type: new ODataString("Id"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("PlanIdentityId"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "components.plancreationwizard.membereligibility.period",
      type: new ODataInteger("CalendarYear", {
        getString: (item) => {
          if (
            !item.IsReevaluation ||
            item.LastPeriodCalendarYear === null ||
            item.LastPeriodCalendarYear === undefined ||
            (item.IsReevaluation &&
              item.LastPeriodCalendarYear == item.CalendarYear &&
              item.LastPeriodCalendarMonth === item.CalendarMonth)
          ) {
            let month = item.CalendarMonth;
            if (month.length === 1) {
              month = `0${month}`;
            }
            return `${month}/${item.CalendarYear}`;
          } else {
            let month = item.CalendarMonth;
            if (month.length === 1) {
              month = `0${month}`;
            }
            let lastMonth = item.LastPeriodCalendarMonth;
            if (lastMonth.length === 1) {
              lastMonth = `0${lastMonth}`;
            }
            return `${month}/${item.CalendarYear} - ${lastMonth}/${item.LastPeriodCalendarYear}`;
          }
        },
      }),
      sortable: false,
      visible: true,
      searchable: true,
      subHeaders: [
        new ODataHeader({
          title: "headers.eligibility_bank.calendar_month",
          type: new ODataInteger("CalendarMonth"),
          sortable: false,
          visible: true,
          searchable: true,
        }),
        new ODataHeader({
          title: "headers.eligibility_bank.last_period_calendar_year",
          type: new ODataInteger("LastPeriodCalendarYear"),
          sortable: false,
          visible: true,
          searchable: true,
        }),
        new ODataHeader({
          title: "headers.eligibility_bank.last_period_calendar_month",
          type: new ODataInteger("LastPeriodCalendarMonth"),
          sortable: false,
          visible: true,
          searchable: true,
        }),
      ],
    }),
    new ODataHeader({
      title: "globals.status",
      type: new ODataEnum("Status", {
        getString: (item) => {
          return i18n.t("enums." + item.Status);
        },
        dropdownItems: enums.EligibilityHourBankEvaluationStatus,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "components.new_claim.created_at",
      type: new ODataDateTime("Timestamp"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new ODataHeader({
      title: "headers.eligibility_bank.completed_at",
      type: new ODataDateTime("CompletedAt"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new ODataHeader({
      title: "headers.eligibility_bank.re_evaluation",
      type: new ODataBoolean("IsReevaluation"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new ODataHeader({
      title: "globals.trigger",
      type: new ODataString("User"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
  ];
}
